import { connect } from "react-redux";
import { MapState, MapDispatch } from "./executions-run.props";
import ExecutionsRun from "../ExecutionsRun";

export default connect(MapState, MapDispatch)(ExecutionsRun);
